import { render, staticRenderFns } from "./ExclamationCircle.vue?vue&type=template&id=5d6b078a&scoped=true&"
import script from "./ExclamationCircle.vue?vue&type=script&lang=js&"
export * from "./ExclamationCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b078a",
  null
  
)

export default component.exports